import { useEffect } from "react";
import { HubspotPickerData } from "../interfaces";
import AppHubspotPickerSignatureEmailInput from "./AppHubspotPickerSignatureEmailInput";
import { ChevronLeftIcon } from "@heroicons/react/outline";

interface Props {
  pickerData: HubspotPickerData;
  active: boolean;
  signatureRequestRecipients: Array<string> | undefined;
  setSignatureRequestRecipients: (recipients: Array<string>) => void;
  onClickBack: () => void;
}

function AppHubspotPickerSignatureEmails(props: Props) {
  const { pickerData, signatureRequestRecipients, setSignatureRequestRecipients } = props;
  const { signatureRequestNumRecipients, signatureRequestInitialRecipients } = pickerData;

  const contactOptions = props.pickerData?.associatedObjectOptions.find((objList) => objList.toId === "contacts")?.items ?? [];

  function handleUpdateRecipient(index: number, value: string) {
    const newRecipients = [...props.signatureRequestRecipients ?? []];
    newRecipients[index] = value;

    setSignatureRequestRecipients(newRecipients);
  }

  useEffect(() => {
    if (signatureRequestInitialRecipients && !signatureRequestRecipients)
      setSignatureRequestRecipients(signatureRequestInitialRecipients);

  }, [signatureRequestRecipients, setSignatureRequestRecipients, signatureRequestInitialRecipients])

  return (
    <>
      <div className="flex items-center gap-1 font-semibold font-gilroy text-sm mb-4">
        <ChevronLeftIcon className="h-6 w-6 text-gray-600 hover:text-blue cursor-pointer" onClick={props.onClickBack} />
        <span className="text-gray-600">Override signature request recipients</span>
      </div>
      <div className="flex flex-col overflow-y-auto h-full mb-4 gap-4">
        {Array.from({ length: signatureRequestNumRecipients }).map((_, index) => (
          <AppHubspotPickerSignatureEmailInput key={index} index={index} value={props.signatureRequestRecipients?.[index] ?? ""} initialValue={signatureRequestInitialRecipients?.[index] ?? ""} setSignatureOverrideRecipients={handleUpdateRecipient} contactOptions={contactOptions} active={props.active} />
        ))}
      </div>
    </>
  );
}

export default AppHubspotPickerSignatureEmails;
